import { Component, OnInit, Injector } from '@angular/core';
import { PurchaseReportServiceProxy, 
        AgedPayableDetailReportDto, 
        GetPurchaseReportInput, 
        OutPurchaseStandingInvoiceReportDto,
        CreateOrEditCompanyDto,
        CreateOrEditLocationDto,
        CommonLookupServiceProxy,
        DropDownLookupDto,
        GetCompanyForEditOutput,
        GetLocationForEditOutput,
 } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from '@node_modules/@types/luxon';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'app-vendor-statement',
  standalone: false,
  templateUrl: './vendor-statement.component.html',
  styles: ``
})


export class VendorStatementComponent extends AppComponentBase implements OnInit {

  loading = false;
  dateRangeSelected = false;
  locations: DropDownLookupDto[] = [];
  selectedLocations: any[] = [];
  purchaseReportOutput: OutPurchaseStandingInvoiceReportDto;
  companyDetails: CreateOrEditCompanyDto;
  locationDetails: CreateOrEditLocationDto;
  vendors: DropDownLookupDto[];
  selectedVendors: any[] = [];
  vendorId : 0;
  dateRange: Date[] = [];
  dateFormat = AppConsts.dateFormat;

  constructor(
            injector: Injector,
        private lookupService: CommonLookupServiceProxy,
        private purchaseReportService: PurchaseReportServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _fileDownloadService: FileDownloadService,
      
    ){
      super(injector);
    }

  ngOnInit(): void {
    this.loadLocations();
    this.initializeDateRange();
    this.getReportDetails();
  }

  loadLocations()
  {
      this._commonLookupServiceProxy.getAllVendorForTableDropdown().subscribe((result) => {
          this.vendors = result;
      });

  }

  initializeDateRange() {
      const today = new Date();
      this.dateRange = [
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
          new Date(today.getFullYear(), today.getMonth(), today.getDate())
      ];
  }

  OnselectDateRange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.dateRangeSelected = isChecked;

    }

  getReportDetails() {

    const selVendors = this.selectedVendors.length
      ? this.selectedVendors
      : [];

    this.loading = true;

    let inputPurchaseReport = new GetPurchaseReportInput();
    //const filterDateStr = moment(this.filterDate).format('YYYY-MM-DD');
    
    //inputPurchaseReport.filterDate = filterDateStr as any;
    inputPurchaseReport.locationId = this.appSession.user.locationId;
    inputPurchaseReport.vendorIds = selVendors as any;

    this.purchaseReportService.getOutStandingInvoices(inputPurchaseReport)
    .subscribe(result => {
      this.purchaseReportOutput = result;
      this.companyDetails = this.purchaseReportOutput.company;
      this.locationDetails = this.purchaseReportOutput.location;
      console.log(result);
      //this.netProfitAmounts = result[0]?.netProfitAmounts || [];
      this.loading = false;
    });
  }

printReportDetails()
{
  //alert(1);
        window.print();
  //alert(2);
}

}